import React, { useContext, useRef } from 'react';
import { FloatingFocusManager, FloatingPortal } from '@floating-ui/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ARROW_DOWN_KEY, ARROW_UP_KEY } from '../../Utils/constant';
import { ActionListContext } from '../ActionList';
import { ActionListSection } from '../ActionListSection';
import moduleStyles from '@dtsl/css-action-list/dist/index.module.css';
function ActionListBody(props) {
  const {
    dataTestId,
    styles,
    floatingStyles,
    refs,
    context,
    isMounted,
    animationStyles
  } = props;
  const actionListBodyRef = useRef();
  const {
    isMobile,
    isOpen,
    focused,
    setFocused
  } = useContext(ActionListContext);
  const actionListBodyClasses = classNames({
    [moduleStyles['sib-action-list__body']]: true
  });
  const handleNextOption = (e, firstOption, nextOption, lastOption, optionList) => {
    var _optionList$selectedO, _optionList$selectedO2, _optionList$selectedO3;
    const selectedOptIndex = focused === lastOption ? firstOption : nextOption;
    Array.from(optionList).forEach(optionList => {
      if (optionList.classList.contains('focused')) {
        optionList.classList.remove('focused');
        optionList.setAttribute('tabindex', '');
      }
    });
    setFocused(selectedOptIndex);
    (_optionList$selectedO = optionList[selectedOptIndex]) === null || _optionList$selectedO === void 0 ? void 0 : _optionList$selectedO.setAttribute('tabindex', '0');
    (_optionList$selectedO2 = optionList[selectedOptIndex]) === null || _optionList$selectedO2 === void 0 ? void 0 : _optionList$selectedO2.classList.add('focused');
    (_optionList$selectedO3 = optionList[selectedOptIndex]) === null || _optionList$selectedO3 === void 0 ? void 0 : _optionList$selectedO3.focus();
  };
  const handleKeyPress = event => {
    const ulElement = document.getElementById('action-list-container');
    if (ulElement) {
      let optionList = [];
      Array.from(ulElement.children).forEach(group => {
        if (group.children.length == 1) {
          var _group$children$;
          Array.from((_group$children$ = group.children[0]) === null || _group$children$ === void 0 ? void 0 : _group$children$.children).forEach(groupChild => {
            if (!groupChild.classList.contains(moduleStyles['sib-action-list__item--disabled'])) {
              optionList.push(groupChild); //Group Options
            }
          });
        }
      });

      if (event.key === ARROW_UP_KEY && !event.target.classList.contains(moduleStyles['sib-action-list__body'])) {
        const last = optionList.length - 1;
        const next = parseInt(focused) - 1;
        handleNextOption(event, last, next, 0, optionList);
      }
      if (event.key === ARROW_DOWN_KEY) {
        const first = 0;
        const next = focused === null ? 0 : parseInt(focused) + 1;
        handleNextOption(event, first, next, optionList.length - 1, optionList);
      }
    }
  };
  const floatingStylesForList = isMobile ? {} : {
    ...floatingStyles
  };
  return isMounted ? /*#__PURE__*/React.createElement(FloatingPortal, null, /*#__PURE__*/React.createElement(FloatingFocusManager, {
    context: context,
    modal: false
  }, /*#__PURE__*/React.createElement("div", {
    ref: refs.setFloating,
    style: {
      ...floatingStylesForList
    }
  }, /*#__PURE__*/React.createElement("ul", {
    role: "menu",
    tabIndex: "0",
    className: actionListBodyClasses,
    onKeyDown: handleKeyPress,
    "data-testid": dataTestId ? dataTestId : null
    //onAnimationEnd={onAnimationEnd}
    ,
    id: "action-list-container",
    ref: actionListBodyRef,
    style: {
      ...styles,
      ...animationStyles,
      animation: isMobile ? `${isOpen ? 'var(--sib-transition_slide-action-list-to-top, slide-action-list-to-top 300ms ease-in)' : 'var(--sib-transition_slide-action-list-to-bottom, 300ms slide-action-list-to-bottom ease-in-out)'}` : {}
    }
  }, /*#__PURE__*/React.createElement(ActionListSection, props))))) : null;
}
ActionListBody.propTypes = {
  dataTestId: PropTypes.string,
  styles: PropTypes.object,
  options: PropTypes.array,
  floatingStyles: PropTypes.object,
  refs: PropTypes.object,
  context: PropTypes.object,
  isMounted: PropTypes.bool,
  animationStyles: PropTypes.object
};
export default ActionListBody;